import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ResponseDataModel } from "@core/models/response-data.model";
import { SKIP_LOADING } from "@core/consts/elusive-headers.constants";
import { RESOURCES } from "@shared/constants/resources.constants";
import { ApiService } from "./api.service";

@Injectable({
  providedIn: "root",
})
export class TermsService {
  private readonly apiService: ApiService = inject(ApiService);

  public acceptTerm$(id: number): Observable<ResponseDataModel> {
    return this.apiService.post<ResponseDataModel>({
      route: RESOURCES.termsAccept,
      body: { id },
      headers: SKIP_LOADING,
    });
  }
}
